const toValidDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const isSameCalendarDay = (dateA, dateB) => {
  const left = toValidDate(dateA);
  const right = toValidDate(dateB);
  if (!left || !right) return false;

  return (
    left.getDate() === right.getDate() &&
    left.getMonth() === right.getMonth() &&
    left.getFullYear() === right.getFullYear()
  );
};

const addDays = (date, days) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);
  return nextDate;
};

const getWorkoutOrder = (workout) => {
  const order = Number(workout?.order);
  return Number.isFinite(order) ? order : 0;
};

export const getWorkoutsSortedByWeekPosition = (workouts, week) =>
  (workouts || [])
    .map((workout, index) => ({ workout, index }))
    .filter(({ workout }) => workout?.week === week)
    .sort(
      (left, right) =>
        getWorkoutOrder(left.workout) - getWorkoutOrder(right.workout) ||
        left.index - right.index
    )
    .map(({ workout }) => workout);

const shouldUpdateAuxDate = (currentValue, nextValue) => {
  const currentDate = toValidDate(currentValue);
  const nextDate = toValidDate(nextValue);

  if (!currentDate && !nextDate) return false;
  if (!currentDate || !nextDate) return true;

  return !isSameCalendarDay(currentDate, nextDate);
};

export const getAddToCalendarAuxDateUpdates = ({
  blockWorkouts,
  selectedWeek,
  totalWeeks,
  workoutsOnCalendar = [],
}) => {
  const workouts = blockWorkouts || [];
  const selectedWeekWorkouts = getWorkoutsSortedByWeekPosition(
    workouts,
    selectedWeek
  );
  const auxDateByWorkout = new Map(
    workouts.map((workout) => [workout, toValidDate(workout?.auxDate)])
  );
  const updates = [];

  const selectedDates = selectedWeekWorkouts
    .map((workout) => toValidDate(workout?.auxDate))
    .filter(Boolean)
    .sort((left, right) => left.getTime() - right.getTime());

  selectedWeekWorkouts.forEach((workout, index) => {
    const nextDate = selectedDates[index] || null;
    auxDateByWorkout.set(workout, nextDate);

    if (shouldUpdateAuxDate(workout?.auxDate, nextDate)) {
      updates.push({ workout, auxDate: nextDate });
    }
  });

  const baseDates = selectedWeekWorkouts.map((workout) =>
    auxDateByWorkout.get(workout)
  );

  for (let week = selectedWeek + 1; week <= totalWeeks; week += 1) {
    const targetWeekWorkouts = getWorkoutsSortedByWeekPosition(workouts, week);

    baseDates.forEach((baseDate, index) => {
      const targetWorkout = targetWeekWorkouts[index];
      if (!targetWorkout) return;

      let nextDate = null;

      if (baseDate) {
        const candidateDate = addDays(baseDate, 7 * (week - selectedWeek));
        const hasPermanentConflict = workoutsOnCalendar.some((workout) =>
          isSameCalendarDay(workout?.date, candidateDate)
        );
        const hasEarlierAuxConflict = workouts
          .filter((workout) => workout?.week < week)
          .some((workout) =>
            isSameCalendarDay(auxDateByWorkout.get(workout), candidateDate)
          );

        if (!hasPermanentConflict && !hasEarlierAuxConflict) {
          nextDate = candidateDate;
        }
      }

      auxDateByWorkout.set(targetWorkout, nextDate);

      if (shouldUpdateAuxDate(targetWorkout?.auxDate, nextDate)) {
        updates.push({ workout: targetWorkout, auxDate: nextDate });
      }
    });
  }

  return updates;
};
